angular.module('lsnBase.deprecated.models')
  .factory('InsuredObjectModel', ['LsnInsuredObjectModelV1',
    function(LsnInsuredObjectModelV1) {
      return LsnInsuredObjectModelV1;
    }
  ]);